const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();


// ------------------------------------------------------------------------
// toggleHeader
// ----- SP
// ------------------------------------------------------------------------
const toggleHeader = () => {

  let headerFlag        = false;
  let stContainer  = document.getElementById('st-Container');
  let stHeader  = document.getElementById('st-Header');
  let headerButtonOpen  = document.getElementById('st-Menu_Open');
  let headerNavigation  = document.getElementById('st-Header_Navigation');

  history.replaceState(null, null, null);
  window.addEventListener('popstate', function() {

    $('body').addClass('preload');

    headerFlag        = false;
    headerNavigation.classList.add('st-Header_Navigation-Hidden');
    headerButtonOpen.classList.remove('close');
    setTimeout(function(){
      $('body').removeClass('preload');
    },100);

  }, false);


  headerButtonOpen.addEventListener('click', () => {
    // headerNavigation.classList.toggle('st-Header_Navigation-Hidden');
    // headerButtonOpen.classList.toggle('close');

    if(!headerFlag){
      headerNavigation.classList.remove('st-Header_Navigation-Hidden');
      headerButtonOpen.classList.add('close');
      headerFlag = true;
    }else{
      headerNavigation.classList.add('st-Header_Navigation-Hidden');
      headerButtonOpen.classList.remove('close');
      headerFlag = false;
    }
  }, false);



};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 500;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};

// ------------------------------------------------------------------------
// newsPosition
// ----- PC
// ------------------------------------------------------------------------
const newsPosition = () => {

  $(window).on("load resize scroll", function(){

    var windowW         = $(window).width();
    var windowH         = $(window).height();
    var scrollPosition  = $(window).scrollTop();
    var indexH          = $('#index-Keyvisual').height();//キービジュアルの高さ
    var logoH           = $('#index-Logo').height();     //ロゴの高さ
    var newsH           = $('.index-News').height();     //NEWSの高さ
    var stopPosition    = indexH - windowH + 90;         //キービジュアルの高さ - ウィンドウの高さ（NEWSの固定を解除する位置）
    var releasePosition = logoH + newsH + 130;           //ロゴ + NEWSの高さ（これ以上ウィンドウの高さが小さい時は固定しない）
    var newsBottom      = indexH - newsH + 50;           //newsの位置(キービジュ下部に合わせるためのtopからの距離)

    //PCの時
    if(windowW >= 768){
      //ウィンドウの高さが小さくてロゴとNEWSがぶつかる場合は、NEWSを固定しない
      if(windowH < releasePosition){
        $('.index-News').css({'position':'absolute','top':newsBottom + 'px','bottom':'auto','left':'30px'});
      }
      //キービジュアル下までスクロールした時、NEWSの固定を解除する
      else if(scrollPosition >= stopPosition){
        $('.index-News').css({'position':'absolute','top':newsBottom + 'px','bottom':'auto','left':'30px'});
      }
      //それ以外の時はNEWSを固定
      else {
        $('.index-News').css({'position':'fixed','top':'auto','bottom':'40px','left':'30px'});
      }
    }
    //SPの時
    else {
      $('.index-News').css({'position':'static','top':'auto','bottom':'auto','left':'auto'});
    }
  });

}


// ------------------------------------------------------------------------
// showIndex
// ----- BOTH
// ------------------------------------------------------------------------
const showIndex = () => {

  $(window).on('load' , function() {
    $("body").removeClass("preload");
    $("#index-Main,#st-Header").removeClass('content-Hidden');
    // $(".light0, .light1").addClass('show');
    setTimeout(function(){
      $(".index-Keyvisual-Content_Bg").removeClass('index-Keyvisual-Content_Bg-Hidden');
    },200);


    setTimeout(function(){
      $(".index-Hidden").addClass('show');
    },700);

    setTimeout(function(){
        $("#st-Header_Navigation").removeClass('st-Header_Navigation-Top');
    },1300);

    setTimeout(function(){
        showPopup();
    },1700);


  });

}


// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
    setTimeout(function(){
      $(".sub-Heading,.sub-Box").addClass('load');
    },50);

  });

};

// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  var windowW         = $(window).width();

  $(window).on('load', function(){

    // $('#preloader').delay(100).animate({'opacity':0}, 700, function(){
    //   $('#preloader').remove();
    // });


    $("#st-Header").removeClass('content-Hidden');
    $("#st-Menu_Open").removeClass('st-Menu_Open-Hidden');
    $("#st-Header_Navigation").removeClass('st-Header_Navigation-Top');
    // if(windowW >= 768){
    //   // $("#st-Header_Navisgation").removeClass('st-Header_Navigation-Top');
    // } else {
    //   $("#st-Top").removeClass('st-Top-Hidden');
    // }
  });

  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
    // if(windowW >= 768){
      if(scrollPosition >= 50){
        $("#st-Top").removeClass('st-Top-Hidden');
      } else {
        $("#st-Top").addClass('st-Top-Hidden');
      }
    // }
  });

  $("#st-Top").on("click", function(){
    var linkSpeed    = 500;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "swing");
    return false;
  });
};

// ------------------------------------------------------------------------
// pageTopIndex
// ----- BOTH
// ------------------------------------------------------------------------
const pageTopIndex = () => {

  // $(window).on("scroll", function(){
  //   var scrollPosition = $(window).scrollTop();
  //
  //   if(scrollPosition >= 50){
  //     $("#st-Menu_Open").removeClass('st-Menu_Open-Hidden');
  //     $("#st-Top").removeClass('st-Top-Hidden');
  //   } else {
  //     $("#st-Menu_Open").addClass('st-Menu_Open-Hidden');
  //     $("#st-Top").addClass('st-Top-Hidden');
  //   }
  //
  // });
  var windowW         = $(window).width();

  $(window).on('load', function(){

    setTimeout(function(){
      $("#st-Header").removeClass('content-Hidden');
      $("#st-Menu_Open").removeClass('st-Menu_Open-Hidden');
      $("#st-Header_Navigation").removeClass('st-Header_Navigation-Top');
      // if(windowW >= 768){
      //   // $("#st-Header_Navigation").removeClass('st-Header_Navigation-Top');
      // } else {
      //   $("#st-Top").removeClass('st-Top-Hidden');
      // }
    },1000);
  });

  $(window).on("scroll", function(){
    var scrollPosition = $(window).scrollTop();
    // if(windowW >= 768){
      if(scrollPosition >= 50){
        $("#st-Top").removeClass('st-Top-Hidden');
      } else {
        $("#st-Top").addClass('st-Top-Hidden');
      }
    // }
  });

  $("#st-Top").on("click", function(){
    var linkSpeed    = 800;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// movieSlider
// ----- SP
// ------------------------------------------------------------------------
const movieSlider = () => {

  var swiper = new Swiper('.swiper-container', {
    loop: true,
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: true,
    spaceBetween: 20,
    simulateTouch: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      hideOnClick: true,
    },
  });


}

// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#movie-Stage');
  const $content = $('#movie-Iframe');

  // open
  $('.js-Youtube').on('click', function(){
    // console.log('AAA');

    const dataID = $(this).attr('data-youtube');

    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},300,'easeOutQuart',function(){


      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;

  	});


  });
  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children('iframe').remove();
		});
    //
    // $modal.stop().fadeOut(300, function(){
    //   $content.children('iframe').remove();
    // });
  });

};

// ------------------------------------------------------------------------
// showPopup
// ----- BOTH
// ------------------------------------------------------------------------
const showPopup = () => {
  const $modalPopup = $('#popup-Stage');

  // open

    $('#popup-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'%','top':0,'left':0},500,'easeOutQuart',function(){

      return false;

  	});


  //close
  $('#popup-Box-Close,#popup-Close').on('click', function(){

    $('#popup-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#popup-Stage').css({'display':'none'});
		});

  });

};




export {
  toggleHeader,
  anchorLink,
  newsPosition,
  showIndex,
  preload,
  pageTop,
  pageTopIndex,
  movieSlider,
  showMovie,
  showPopup
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js